<template>

    <div>

        <label v-if="position">Taxon {{ position }}:</label>
        <label v-if="!position">Interaction:</label>
        <br />
        <input type="text" required v-model="user_query[field_name]" /><br />
        <span class="info">Example: {{ example }}</span><br /><br />

        <div v-if="user_query[field_name] != ''">

            <div v-if="norm_term">

                <div v-if="list_terms.length > 0">
                    <div class="norm" :key="list_terms[0].id">
                        <input type="radio" :name="name" :value="list_terms[0].concept_id" v-model="selected_id" @click="changeNorm(0)">
                        <label :for="list_terms[0].concept_id">{{ list_terms[0].preferred_term }} [{{
                                list_terms[0].concept_id
                        }}]</label>
                        <br /><br />
                    </div>
                    <div v-if="list_terms.length > 1">
                        <p v-if="position">Or select another taxonomic entity:</p>
                        <p v-if="!position">Or select another ROBI concept:</p>
                        <PanelMoreLess :visible_length="item_size" :items_length="list_terms.length"
                            message_more="More" message_less="Less">

                            <template slot="default-list">
                                <div class="norm" v-for="(term,index) in list_terms.slice(1, item_size)" :key="term.id">
                                    <input type="radio" :name="name" :value="term.concept_id" v-model="selected_id" @click="changeNorm(index+1)">
                                    <label :for="term.concept_id">{{ term.preferred_term }} [{{ term.concept_id
                                    }}]</label>
                                    <br>
                                </div>
                            </template>

                            <template slot="extra-list">
                                <div class="norm" v-for="(term, index) in list_terms.slice(item_size, list_terms.length)"
                                    :key="term.id">
                                    <input type="radio" :name="name" :value="term.concept_id" v-model="selected_id" @click="changeNorm(index+item_size)">
                                    <label :for="term.concept_id">{{ term.preferred_term }} [{{ term.concept_id
                                    }}]</label>
                                    <br>
                                </div>
                            </template>

                        </PanelMoreLess>
                    </div>
                </div>
                <div v-else>
                    <p v-if="position" class="required">taxon not found</p>
                    <p v-if="!position" class="required">interaction not found</p>
                    <br />
                </div>

            </div>
            <div v-else>
                <PulseLoader :color="theme_color.main" :size="'5px'"/>
            </div>

        </div>
    </div>

</template>


<script>
import { mapState } from 'vuex'
import axios from 'axios';
import PanelMoreLess from '@/components/PanelMoreLess.vue'
var PulseLoader = require('vue-spinner/src/PulseLoader.vue').default;

    export default {
      name: 'NormalizedComponent',
      components: {
        PanelMoreLess,
        PulseLoader,

      },
      props: {
        name: {
            type: String,
            required: true
        },
        position: {
            type: String,
        },
        example: {
            type: String,
            required: true
        }
      },
      data() {
        return {
            norm_term: false,
            list_terms: null,
            item_size: 6,
            selected_id: "",
            selected_pt: "",
            timer: null,
        };
      },
      computed: {
        ...mapState(['theme_color', 'urls', 'user_query']),
        cssVars () {
            return{
                '--color': this.theme_color.main,
            }
        },
        field_name (){
            if (this.position){
                return "taxon"+this.position
            }
            else {
                return "interaction"
            }
        }
      },
      methods:{
        changeNorm(element_position){
            this.selected_pt = this.list_terms[element_position]["preferred_term"]
            if (this.position){
                this.$matomo?.trackEvent("Select normalization ", "taxon"+this.position+":"+element_position);
            }
            else {
                this.$matomo?.trackEvent("Select normalization ", "interaction:"+element_position);               
            }
        },
        searchWithTimer(term){
            this.norm_term = false
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                this.normalize(term)
            }, 500);
        },
        normalize(term){
            if (term != ""){
                var url = this.urls.normalize
                if (this.position){
                    url += "/taxon"
                }
                else{
                    url += "/interaction"
                }
                url += "?term="+term
                axios
                    .get(url)
                    .then(response => {
                        this.norm_term = true
                        if (response.data.results.length == 0){
                            this.user_query[this.field_name+"_id"] = ""
                            this.list_terms = []
                            this.selected_id = ""
                            this.selected_pt = ""
                        }
                        else {
                            this.list_terms = response.data.results
                            this.user_query[this.field_name+"_id"] = response.data.results[0].concept_id
                            this.selected_id = response.data.results[0].concept_id
                            this.selected_pt = response.data.results[0].preferred_term
                        }
                    })
                    .catch(error => {
                        if (this.position){
                            alert ("Failed to normalize taxon: "+error)
                        }
                        else {
                            alert ("Failed to normalize interaction: "+error)
                        }
                    })
            }
            else {
                this.user_query["taxon"+this.position+"_id"] = ""
                this.list_terms = []
                this.selected_id = ""  
                this.selected_pt = ""             
            }

        },
      },
      watch: {
        'selected_id': function(){
            this.user_query[this.field_name+"_id"] = this.selected_id
        },
        'selected_pt': function(){
            this.user_query[this.field_name+"_pt"] = this.selected_pt
        },
        'user_query.taxon1': function(){
            if(this.position == "1"){
                this.searchWithTimer(this.user_query.taxon1)
            }
        },
        'user_query.taxon2': function(){
            if(this.position == "2"){
                this.searchWithTimer(this.user_query.taxon2)
            }
        },
        'user_query.interaction': function(){
            if(this.position == null){
                this.searchWithTimer(this.user_query.interaction)
            }
        }
      },
      mounted() {
        if(this.position == "1"){
            this.searchWithTimer(this.user_query.taxon1)
        }
        if(this.position == "2"){
            this.searchWithTimer(this.user_query.taxon2)
        }
        if(this.position == null){
            this.searchWithTimer(this.user_query.interaction)
        }
      }

    }

</script>


<style scoped lang="scss">



    label {
        width: 80px;
        font-weight: bold;
    }

    input {
      width: 100%;
      padding-left: 5px;
      background-color: #fff;
      border: 1px solid grey;
      border-radius: 5px;
   }


   .norm input{
     width: 10%
   }

   .norm label{
     width: 90%
   }

</style>
